import React from "react";
import { safeHtmlParser } from './htmlParser';

export const htmlParser = item => {
  if (item == null) {
    return null;
  }
  return <span>{safeHtmlParser(String(item))}</span>;
};
